import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect x="1" y="1" width="30" height="30" rx="8" fill="#0F111A" stroke="rgba(255,255,255,0.14)" />
    <path d="M20.5 10.5a7 7 0 1 0 0 11" fill="none" stroke="#F8FAFC" strokeWidth="2.6" strokeLinecap="round" />
    <circle cx="22.5" cy="16" r="2.2" fill="#FF5500" />
  </svg>
);

export const Logo = ({ testId = "nav-logo" }) => (
  <Link to="/" data-testid={testId} className="flex items-center gap-2.5 rounded-md focus-ring" aria-label="CARLINK home">
    <LogoMark />
    <span className="font-display text-lg font-extrabold tracking-[0.18em] text-slate-50">CARLINK</span>
  </Link>
);
